/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Injectable } from '@angular/core';

import {
  CardResponse,
  PaymentMethodApiService,
  Reservation,
  ReservationRequest,
  ReservationsApiService,
} from 'rest-client';
import { from, Observable } from 'rxjs';

@Injectable()
export class ReservationService {
  constructor(
    private reservationsApiService: ReservationsApiService,
    private paymentMethodApiService: PaymentMethodApiService
  ) { }

  createReservation(
    reservation: ReservationRequest,
    isGuestUser: boolean
  ): Observable<Reservation> {
    return from(
      this.reservationsApiService.createReservation(reservation, isGuestUser)
    );
  }

  checkCard(id: number): Observable<CardResponse> {
    return from(this.paymentMethodApiService.checkCard(id));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cancelReservationPayment(id: number): Observable<any> {
    return from(this.paymentMethodApiService.cancelReservationPayment(id));
  }

  updateReservation(
    //deprecated method at API
    reservation: ReservationRequest,
    isGuestUser: boolean
  ): Observable<Reservation> {
    return from(
      this.reservationsApiService.updateReservation(reservation, isGuestUser)
    );
  }

  update(id: number, payload: unknown): Observable<Reservation> {
    return from(this.reservationsApiService.update(id, payload));
  }

  getReservation(reservationId: number): Observable<Reservation> {
    return from(this.reservationsApiService.getReservation(reservationId));
  }

  getReservationByHash(reservationToken: string, format?: string): Observable<Reservation> {
    // http://localhost:4200/confirmation?reservation_token=res_1997752_864377938
    const id = reservationToken.split('_')[1];
    const hash = reservationToken.split('_')[2];
    return from(
      this.reservationsApiService.getReservationByHash(Number(id), hash, false, format)
    );
  }
}
